import { render, staticRenderFns } from "./editotherrule.vue?vue&type=template&id=16ceb8d8"
import script from "./editotherrule.vue?vue&type=script&lang=js"
export * from "./editotherrule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports